import { MISSED } from 'constants/deals'

export const tableStatusBtns = [
  {
    label: 'Все'
  },
  {
    label: 'На согласование',
    code: ['on_approval']
  },
  {
    label: 'РЛ Октелл'
  },
  {
    label: 'Закрытые упущенные',
    code: [MISSED]
  },
  {
    label: 'SMM'
  }
]
